import React from 'react';
import { Modal } from '../../../components/common/Modal';
import { useLanguage } from '../../../features/language/useLanguage';
import type { BulkBlockedCard } from './useBulkWorkOrders';

interface Props {
  blocked: BulkBlockedCard[] | null;
  onClose: () => void;
}

/**
 * The bulk counterpart of the single form's "Roast type is required." warning:
 * names every card that is short of a required field, and what is missing.
 * Nothing has been written when this shows.
 */
export const BulkMissingFieldsModal: React.FC<Props> = ({ blocked, onClose }) => {
  const { t } = useLanguage();
  if (!blocked) return null;

  return (
    <Modal isOpen onClose={onClose} title={t('workOrders.modals.warning')}>
      <div className="space-y-4" data-test-id="wo-bulk-missing-fields-modal">
        <p className="text-sm text-gray-700">{t('workOrders.bulk.missingFieldsBody')}</p>
        <ul className="space-y-1 rounded-md bg-gray-50 p-3 text-sm text-gray-800">
          {blocked.map((card) => (
            <li key={card.index} data-test-id={`wo-bulk-missing-fields-${card.index}`}>
              <span className="font-medium">
                {card.code || t('workOrders.bulk.scheduleTitle', { index: card.index + 1 })}
              </span>
              {': '}
              {card.issues.map((issue) => t(`workOrders.bulk.issues.${issue}`)).join(', ')}
            </li>
          ))}
        </ul>
        <div className="flex justify-end pt-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            data-test-id="wo-bulk-missing-fields-ok"
          >
            {t('workOrders.modals.ok')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
